// Core Components
import MDCButton from "../core/MDCButton";
import MDCModal from "../core/MDCModal";
// Material UI
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
// Assets
import carLogo from "../../assets/images/my_digital_car.svg";
import ArchiveIconWithBackground from "../iconComponents/ArchiveIconWithBackground";
// Constants
import {
  ARCHIVE_RECORD_DIALOG_CONTENT,
  ARCHIVE_RECORD_DIALOG_TITLE,
  BACK_BUTTON_LABEL,
  CONFIRM_BUTTON_LABEL,
} from "../../constants/VorgangDetailsConstants";
import MDCLoader from "../core/MDCLoader";

const ArchiveRecordDialog = ({ open, onCancel, onConfirm, showLoader }) => {
  const useStyles = makeStyles((theme) => ({
    displayBetween: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    bodyInfo: {
      color: theme.palette.MDCColors.color15,
    },
  }));
  const { displayBetween, bodyInfo } = useStyles(); //getting css styles to be used as className

  const getModalBody = () => {
    return showLoader ? (
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        height="25rem"
      >
        <MDCLoader />
      </Grid>
    ) : (
      <Grid padding="2rem">
        {/* Header */}
        <Grid className={displayBetween}>
          <Grid item xs={5}>
            <h3>{ARCHIVE_RECORD_DIALOG_TITLE}</h3>
          </Grid>
          <Grid item xs={7} textAlign="end">
            <img alt="My Digital Car" src={carLogo} width="80%" />
          </Grid>
        </Grid>

        {/* Body */}
        <Grid container flexDirection="column" marginY={"2.5rem"}>
          <Grid container justifyContent="center" marginBottom={"2rem"}>
            <ArchiveIconWithBackground />
          </Grid>
          <Grid className={bodyInfo} textAlign="left">
            <p>{ARCHIVE_RECORD_DIALOG_CONTENT}</p>
          </Grid>
        </Grid>

        {/* Footer */}
        <Grid className={displayBetween} marginTop="1rem">
          <MDCButton
            variant={"outlined"}
            label={BACK_BUTTON_LABEL}
            onClick={onCancel}
          />
          <MDCButton
            variant={"contained"}
            label={CONFIRM_BUTTON_LABEL}
            onClick={onConfirm}
          />
        </Grid>
      </Grid>
    );
  };

  return <MDCModal open={open} body={getModalBody()} size="sm" />;
};

export default ArchiveRecordDialog;
